// Generated by CoffeeScript 1.12.4
(function() {
  var endsWith, faker;

  faker = require('faker/locale/en');

  endsWith = function(input, search) {
    var lastIndex, position;
    if (!input) {
      return false;
    }
    position = input.length - search.length;
    lastIndex = input.indexOf(search, position);
    return lastIndex !== -1 && lastIndex === position;
  };

  module.exports = function(refract, path) {
    var last, ref, ref1;
    last = path.length - 1;
    switch (refract.element) {
      case 'boolean':
        return faker.random.boolean();
      case 'number':
        switch (path[last]) {
          case 'cost':
          case 'price':
            return parseFloat(faker.finance.amount());
          default:
            return faker.random.number();
        }
        break;
      case 'string':
        switch (path[last]) {
          case 'id':
          case 'uid':
          case 'uuid':
            return faker.random.uuid();
          case 'firstname':
            return faker.name.firstName();
          case 'lastname':
            return faker.name.lastName();
          case 'name':
            if (path.length > 1 && ((ref = path[last - 1]) === 'user' || ref === 'userinfo' || ref === 'customer' || ref === 'account' || ref === 'client')) {
              return faker.name.findName();
            } else if (path.length > 1 && ((ref1 = path[last - 1]) === 'company' || ref1 === 'business')) {
              return faker.company.companyName();
            } else {
              return faker.lorem.words(1);
            }
            break;
          case 'username':
            return faker.internet.userName();
          case 'email':
            return faker.internet.email();
          case 'url':
          case 'uri':
          case 'href':
          case 'host':
          case 'hostname':
          case 'website':
            return faker.internet.url();
          case 'password':
          case 'pass':
            return faker.internet.password();
          case 'image':
          case 'avatar':
            return faker.image.image();
          case 'address':
          case 'location':
          case 'street':
            return faker.address.streetAddress();
          case 'city':
            return faker.address.city();
          case 'state':
            return faker.address.stateAbbr();
          case 'country':
            return faker.address.countryCode();
          case 'zip':
          case 'zipcode':
            return faker.address.zipCode();
          case 'lat':
          case 'latitude':
            return faker.address.latitude();
          case 'lng':
          case 'longitude':
            return faker.address.longitude();
          case 'date':
          case 'datetime':
          case 'timestamp':
            return faker.date.past();
          case 'cost':
          case 'price':
            return faker.finance.amount();
          case 'currency':
            return faker.finance.currencyCode();
          default:
            if (endsWith(path[last], 'date') || endsWith(path[last], 'datetime') || endsWith(path[last], 'timestamp')) {
              return faker.date.past();
            } else {
              return faker.lorem.words();
            }
        }
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/eidolon/lib/default-value.js
// module id = 123
// module chunks = 0